import { createSlice } from '@reduxjs/toolkit';
import { resetStore } from '../../Actions';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
import { LoginModuleApi } from '../../../utils/Apis';

const initialState = {
  login_grid: null,
  user_profile: null,
  recommended_bank: null
};

const LoginModule = createSlice({
  name: 'LoginModule',
  initialState,
  reducers: {
    setLoginModuleGrid(state, action) {
      state.login_grid = action.payload;
    },
    setUserProfileCards(state, action) {
      state.user_profile = action.payload;
    },
    setRecommendedBank(state, action) {
      state.recommended_bank = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// Login Grid
export const getLoginGridData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: LoginModuleApi?.loginList,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setLoginModuleGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setLoginModuleGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Login Grid failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Login Grid exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const getLoginUserProfile = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: `${LoginModuleApi?.loginUserProfile}/${data}`,
      method: 'get',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setUserProfileCards(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setUserProfileCards(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌setUser Profile Cards failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 setUser Profile Cards exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};
export const getRecoRecommendedBank = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: `${LoginModuleApi?.recoRecommendedBank}/${data}`,
      method: 'get',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setRecommendedBank(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setRecommendedBank(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌setUser recommended bank list failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 setUser recommended bank list exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// login approve process
export const getLoginApproveProcess = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: LoginModuleApi?.loginApproveProcess,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      return res?.data;
    } else {
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ login approve process failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 login approve process exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const { setLoginModuleGrid, setUserProfileCards, setRecommendedBank } = LoginModule.actions;
export default LoginModule.reducer;
